// Chips are multi-select. Clicking a non-`all` chip toggles it in/out
// of `activeCategories`. `'all'` is a virtual clear-all — active when
// nothing else is. Label shows `(N)` match count under current
// kind/pricing/query filters (see `categoryCount`). Zero-match chips
// fade to opacity 0.4 so they read as "probably not useful" without
// being disabled.

export const MarketplaceCategoryItem = {
  extends: 'Button',
  padding: 'X A',
  borderRadius: 'C',
  background: (el) => {
    const host = el.call('marketplaceHostOf', el)
    return el.call('isCategoryActive', host, el.key) ? 'blue' : 'line'
  },
  color: (el) => {
    const host = el.call('marketplaceHostOf', el)
    return el.call('isCategoryActive', host, el.key) ? 'white' : 'caption'
  },
  fontWeight: (el) => {
    const host = el.call('marketplaceHostOf', el)
    return el.call('isCategoryActive', host, el.key) ? '600' : '400'
  },
  opacity: (el) => {
    const host = el.call('marketplaceHostOf', el)
    if (el.call('isCategoryActive', host, el.key)) return '1'
    const n = el.call('categoryCount', host, el.key)
    return n === 0 ? '0.4' : '1'
  },
  fontSize: 'Y',
  whiteSpace: 'nowrap',
  text: (el) => {
    const host = el.call('marketplaceHostOf', el)
    const n = el.call('categoryCount', host, el.key)
    if (el.key === 'all') return `all (${n})`
    return n > 0 ? `${el.key} (${n})` : el.key
  },
  ':hover': { opacity: '0.8' },

  onClick: (e, el) => {
    const host = el.call('marketplaceHostOf', el)
    el.call('toggleCategory', host, el.key)
  }
}
